import { PHONE, locationSchema } from "../structured-data-core";

export function getQueensStructuredData() {
  const url = "https://restorehair.com/locations/new-york/queens/";
  const description =
    "Find out about your hair transplant options in Queens with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Queens", "118-35 Queens Blvd, Forest Hills Tower", "Queens", "NY", PHONE, url, description),
  ];
}
